export default {
    'invoiceCarrier.title': 'レシートツール',
    'invoiceCarrier.error.format.one': 'レシートツールのバーコードの形式が間違っています。例: 未入力または文字列の長さが不正です。',
    'invoiceCarrier.error.format.two': '「/」で始まるレシートツールのバーコードを入力してください (例: /A123456)',
    'invoiceCarrier.save': '保存',
    'invoiceCarrier.setting_complete': 'レシートツールのバーコードの設定が完了しました',
} as Record<string, string>;
